import {
	Typography,
	Menu,
	MenuItem,
	Button,
	Avatar,
	IconButton,
	TextField,
	CircularProgress,
	Collapse
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { api } from '../../services/api'
import { GroomingToolbar } from '../../components/Tables/Toolbars/Grooming/GroomingToolbar'
import { getChipStyles, getDogIssues } from '../../services/helpers'
import {
	ArrowBackIosOutlined,
	ArrowForwardIosOutlined,
	KeyboardArrowDown,
	KeyboardArrowUp,
	MoreHoriz,
	Close
} from '@material-ui/icons'
import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
import { KeyboardTimePicker } from '@material-ui/pickers'
import HoverPopover from 'material-ui-popup-state/HoverPopover'
import PopupState, { bindHover, bindPopover } from 'material-ui-popup-state'
import { GroomingAssignmentFilters } from '../../components/Tables/Components/Schedule/GroomingAssignmentFilters'
import Confirmation from '../../components/Dialogs/DeleteConfirmation'
import { STATUS_ID, BOARDING, GROOMING_DEFAULT_EMPTY_VALUE } from '../../utils'
import { updateVisitAsync } from '../../actions/visits/visits.actions'
import { showError } from '../../actions/misc/misc.actions'
import { gray, purple } from '../../utils/colors'
import _ from 'lodash'
import useQuery from '../../hooks/useQuery'
import PetAlert from '../../components/Common/PetAlert'

const localizer = momentLocalizer(moment)

const getSize = (pet) => {
	if (pet.height) return pet.height
	if (pet.weight <= 12) {
		return 'xs'
	} else if (pet.weight >= 13 && pet.weight < 31) {
		return 's'
	} else if (pet.weight >= 31 && pet.weight < 48) {
		return 'm'
	} else if (pet.weight >= 48 && pet.weight < 71) {
		return 'l'
	} else if (pet.weight >= 71) {
		return 'xl'
	} else {
		return 'n/a'
	}
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	toolbar2: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center'
	},
	barOuter: {
		width: '23%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginRight: 24,
		minWidth: 280
	},
	assignment: {
		width: '100%',
		backgroundColor: gray[100],
		padding: 16,
		paddingTop: 8,
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		gap: '.6rem',
		'& .MuiSvgIcon-root': {
			color: gray[700],
			fill: gray[700]
		}
	},
	assignmentInnerContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '1.75rem'
	},
	outer: {
		width: '100%',
		padding: 16,
		'& .MuiTextField-root': {
			minWidth: '250px !important'
		},
		paddingBottom: 0
	},
	topRow: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		paddingLeft: 24,
		paddingRight: 24,
		gap: 24
	},
	petSection: {
		width: '26%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start'
	},
	avatar: {
		height: 85,
		width: 85,
		marginRight: 16
	},
	sectionTitle: {
		fontSize: 14,
		fontWeight: '800',
		color: purple[600],
		letterSpacing: 0.75,
		textTransform: 'uppercase'
	},
	sectionText: {
		fontSize: 14,
		fontWeight: '600',
		color: gray[900],
		marginTop: 8
	},
	section: {
		display: 'flex',
		width: '22%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	sectionFourCols: {
		display: 'flex',
		width: '25%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	sectionTwoCols: {
		display: 'flex',
		width: '50%',
		flexDirection: 'column'
	},
	sectionTwoColsContainer: {
		background: gray[200],
		borderRadius: '.375rem',
		padding: '.5rem 1rem',
		display: 'flex',
		flexDirection: 'column',
		gap: '.375rem'
	},
	loading: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: '100vh',
		right: 0,
		opacity: 0.5,
		backgroundColor: gray[100],
		justifyContent: 'center',
		paddingBottom: 140,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingLeft: 200,
		zIndex: 999
	},
	nameRow: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		paddingLeft: 10,
		marginBottom: 16,
		marginTop: 16
	},
	nameRowInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		cursor: 'pointer',
		alignItems: 'center',
		height: 42,
		backgroundColor: gray[300],
		width: '100%',
		padding: '0px 16px',
		borderTopLeftRadius: 6,
		borderTopRightRadius: 6,
		overflow: 'hidden',
		'& .MuiSvgIcon-root': {
			color: gray[700],
			fill: gray[700]
		}
	},
	name: {
		fontSize: 15,
		color: gray[900],
		fontWeight: '700'
	},
	eventText: {
		fontSize: 13,
		color: gray[900],
		fontWeight: '700',
		marginRight: 3,
		lineHeight: '17px'
	},
	eventText2: {
		fontSize: 13,
		color: gray[900],
		fontWeight: '600',
		lineHeight: '17px',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis'
	},
	popup: {
		borderRadius: 8,
		minWidth: 306,
		backgroundColor: gray[100],
		paddingTop: 12,
		paddingBottom: 12,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start'
	},
	popupLeft: {
		paddingLeft: 16,
		paddingRight: 16,
		fontSize: 16
	},
	popupRight: {
		paddingTop: 2,
		paddingRight: 16
	},
	popupTitle: {
		fontSize: 16,
		color: gray[900],
		fontWeight: '600',
		marginBottom: 4
	},
	popupDate: {
		fontSize: 12,
		fontWeight: '600',
		color: gray[700]
	},
	popupError: {
		fontSize: 12,
		fontWeight: '600',
		color: '#EB4C4C',
		marginTop: 12
	},
	topBtns: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end'
	},
	'& .MuiSvgIcon-root': {
		color: '#3B0275',
		fill: '#3B0275'
	},
	groomerText: {
		color: gray[800],
		fontSize: 13,
		fontWeight: '600',
		lineHeight: '17px',
		marginBottom: 4
	},
	petNameContainer: { display: 'flex', gap: '.5rem', alignItems: 'center' }
}))

const GroomingAssignment = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const { query } = useQuery()
	const date = query.get('date')
	const dispatch = useDispatch()
	// const theme = useTheme()
	// const facilities = useSelector((state) => state.specific.facilities.facilities)
	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const time_zone = selectedFacility?.time_zone || 'America/New_York'

	const { facilityId } = useParams()
	const [loading, setLoading] = useState(false)
	const [staff, setStaff] = useState([])
	const [visits, setVisits] = useState([])
	const [index, setIndex] = useState(0)
	const [visit, setVisit] = useState(null)
	const [needsAssignment, setNeedsAssignment] = useState([])
	const [manual, setIsManual] = useState(false)
	const [specialKey, setKey] = useState(1)

	const isBeforeToday = moment(date, 'YYYY-MM-DD').isBefore(moment().startOf('day'))

	const getRemovedStaffs = (visits, shifts) => {
		const visitsWithStaff = visits.filter((v) => !!v.staff_id)
		const removedShiftsVisits = visitsWithStaff.filter((v) => {
			return !shifts.some(({ staff_id }) => staff_id === v.staff_id)
		})
		return removedShiftsVisits.map(({ staff_id }) => staff_id)
	}

	const fetchVisits = useCallback(async () => {
		try {
			if (facilityId && date) {
				setLoading(true)

				let { data } = await api.get(`/groomingVisits/${facilityId}?date=${date}`)

				const removedStaffIds = getRemovedStaffs(data.visits, data.shifts)
				const modifiedVisits =
					data.visits &&
					data.visits.map((v) => {
						if (removedStaffIds.includes(v.staff_id)) {
							return { ...v, staff_id: null }
						}
						return { ...v }
					})
				setVisits(data.visits)
				setStaff(data.shifts)

				if (!isBeforeToday) {
					const unassignCondition = ({ start_time, staff_id, status }) =>
						!start_time || !staff_id || status?.id === 1
					let unass = modifiedVisits.filter(unassignCondition) || []
					setNeedsAssignment(unass)
					let vis = unass.length > 0 ? unass[0] : false
					if (vis) setVisit(_.cloneDeep(vis))
				} else {
					setVisit(null)
				}

				let mappedStaff = data.shifts.map((s) => {
					return {
						label: s.full_name,
						value: s.full_name
					}
				})

				dispatch({ type: 'SET_GROOMING_TEAM', payload: mappedStaff })

				setKey(JSON.stringify(data.shifts))
				setLoading(false)
			}
		} catch (e) {
			console.log(e)
			setLoading(false)
		}
	}, [date, facilityId])

	const selectEvent = (ev) => {
		const vis = visits.find((v) => v._id === ev.visit._id)
		setVisit(vis)
		setIsManual(true)
	}

	const assignVisit = async (obj) => {
		try {
			setLoading(true)

			const { visit_id, start_time, staff_id } = obj

			await api.put(`/groomingVisits/${obj.visit_id}`, obj)

			const newVisits = visits.map((v) => {
				if (v._id === visit_id) {
					return {
						...v,
						staff_id,
						start_time
					}
				}

				return v
			})
			setVisits(newVisits)

			const removedStaffIds = getRemovedStaffs(newVisits, staff)
			const modifiedVisits = newVisits.map((v) => {
				if (removedStaffIds.includes(v.staff_id)) {
					return { ...v, staff_id: null }
				}
				return { ...v }
			})

			let unass = modifiedVisits.filter((v) => !v.start_time || !v.staff_id || v?.status?.id === 1)
			setNeedsAssignment(unass)

			let max = unass.length - 1

			let newIndex
			if (index >= max) {
				newIndex = 0
			} else {
				newIndex = index + 1
			}

			if (staff_id) {
				let newStaff = staff.map((s) => {
					if (s.staff_id === staff_id) {
						const vis_mins = s.vis_mins + visit.duration
						const capacity = ((vis_mins / s.total_shift_minutes) * 100).toFixed(2)
						const capacity_string = `${capacity}% full`

						return {
							...s,
							remaining_minutes: s.remaining_minutes - visit.duration,
							vis_mins,
							capacity_string
						}
					} else if (s.staff_id === visit?.prev_staff_id) {
						const vis_mins = s.vis_mins - visit.duration
						const capacity = ((vis_mins / s.total_shift_minutes) * 100).toFixed(2)
						const capacity_string = `${capacity}% full`

						return {
							...s,
							remaining_minutes: s.remaining_minutes + visit.duration,
							vis_mins,
							capacity_string
						}
					} else {
						return s
					}
				})

				setStaff(newStaff)
			}

			setIndex(newIndex)

			setIsManual(false)

			setLoading(false)
		} catch (e) {
			console.log(e)
			setLoading(false)
		}
	}

	useEffect(() => {
		if (!manual) {
			if (needsAssignment[index]) {
				let vis = _.cloneDeep(needsAssignment[index])
				setVisit(vis)
			} else {
				setVisit(null)
			}
		}
	}, [index, manual, needsAssignment])

	useEffect(() => {
		fetchVisits()
	}, [fetchVisits])

	const addAppt = () => {
		history.push(`/facilities/${facilityId}/appointment/create?type=grooming`)
	}

	const incrementDate = (type) => {
		let newDate
		if (type === 'add') {
			newDate = moment(date).add(1, 'day').format('YYYY-MM-DD')
		} else if (type === 'subtract') {
			newDate = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
		}
		history.push(`/facilities/${facilityId}/groomingAssignment?date=${newDate}`)
	}

	const updateDate = (newDate) => {
		history.push(`/facilities/${facilityId}/groomingAssignment?date=${moment(newDate).format('YYYY-MM-DD')}`)
	}

	const assignedStaff =
		visit?.staff_id && staff?.length ? staff.find((s) => s.staff_id === visit.staff_id) : null

	const approveVisit = async (visit) => {
		if (!visit || visit.status?.id !== STATUS_ID.Pending) {
			return
		}
		try {
			const status = { id: STATUS_ID.Approved, name: 'Approved' }
			setLoading(true)
			await updateVisitAsync(dispatch, { visit_id: visit._id, updates: { status } })
			setVisit({ ...visit, status })
			setVisits((prev) => {
				const newVisits = prev?.map?.((v) => {
					const { _id } = v
					if (visit._id !== _id) {
						return v
					}
					v.status = status
					return v
				})
				return newVisits
			})

			const updatedNeedsAssignment =
				needsAssignment?.map((v) => {
					const { _id } = v
					if (visit._id !== _id) {
						return v
					}
					v.status = status
					return v
				}) || []

			const filteredNeedsAssignment = updatedNeedsAssignment.filter((v) => {
				return !v.start_time || !v.staff_id || v?.status?.id === 1
			})

			setNeedsAssignment(filteredNeedsAssignment)

			let max = filteredNeedsAssignment.length - 1

			let newIndex
			if (index >= max) {
				newIndex = 0
			} else {
				newIndex = index + 1
			}

			setIndex(newIndex)
		} catch (e) {
			showError('Error approving visit.')
		} finally {
			setLoading(false)
		}
	}

	return (
		<div className={classes.root}>
			{loading ? (
				<div className={classes.loading}>
					<CircularProgress />
				</div>
			) : null}
			<GroomingToolbar
				addAppt={addAppt}
				date={date}
				changeDate={incrementDate}
				updateDate={updateDate}
				title="Grooming Assignment"
			/>
			<Assignment
				isBeforeToday={isBeforeToday}
				assignedStaff={assignedStaff}
				setStaff={(s) => {
					setVisit({ ...visit, staff_id: s })
				}}
				facility={selectedFacility}
				index={index}
				needsAssignment={needsAssignment}
				setIsManual={setIsManual}
				manual={manual}
				visit={visit}
				staff={staff}
				assignVisit={assignVisit}
				approveVisit={approveVisit}
				back={() => {
					let newIndex
					if (index === 0) {
						newIndex = needsAssignment.length - 1
					} else {
						newIndex = index - 1
					}

					setIndex(newIndex)
				}}
				next={() => {
					let max = needsAssignment.length - 1
					let newIndex
					if (index === max) {
						newIndex = 0
					} else {
						newIndex = index + 1
					}

					setIndex(newIndex)
				}}
				time_zone={time_zone}
			/>
			<Calendars
				specialKey={specialKey}
				date={moment(date).toDate()}
				staff={staff}
				time_zone={time_zone}
				visits={visits}
				selectedVisitId={visit?._id}
				selectEvent={selectEvent}
			/>
		</div>
	)
}

const Assignment = ({
	staff,
	visit,
	facility,
	next,
	back,
	assignVisit,
	setIsManual,
	manual,
	needsAssignment,
	index,
	isBeforeToday,
	approveVisit,
	time_zone
}) => {
	const classes = useStyles()
	const [daycareWarning, showDaycareWarning] = useState(false)
	const [selectedDate, handleDateChange] = useState(null)
	const [selectedStaff, handleStaffChange] = useState('')
	const [timeError, setTimeError] = useState(false)
	const [timeErrorText, setTimeErrorText] = useState(null)
	const [anchorEl, setAnchorEl] = React.useState(null)
	const [tempDate, setDate] = useState(null)
	const [prog, setProg] = useState(false)

	const [visitStatus, setVisitStatus] = useState({})
	const hasARelatedBoardingVisit = visit?.related_visits?.some((v) => v.type === BOARDING) || false

	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	const valueRef = useRef('')

	useEffect(() => {
		if (!selectedDate || !selectedStaff) {
			setTimeError(false)
			setTimeErrorText('')
		} else {
			let ourStaff = staff.find((s) => s.staff_id === selectedStaff)

			let base_day = moment(ourStaff.StartTimeLocalized).format('YYYY-MM-DD')

			let shift_start = moment(ourStaff.StartTimeLocalized)
			let shift_end = moment(ourStaff.EndTimeLocalized)
			let shift_final = moment(ourStaff.EndTimeLocalized).add(30, 'minutes')
			let facilityStart = moment(`${base_day} ${facility?.services?.grooming?.visit_start_time}`)

			let added = moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').add(visit.duration, 'minutes')

			if (selectedDate !== 'Invalid date') {
				if (moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isBefore(facilityStart)) {
					setTimeError(true)
					setTimeErrorText('Start time cannot be before facility visit start time.')
				} else if (moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isBefore(shift_start)) {
					setTimeError(true)
					setTimeErrorText('Start time cannot be before shift start.')
				} else if (moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isAfter(shift_end)) {
					setTimeError(true)
					setTimeErrorText('Start time cannot be after shift end.')
				} else if (
					visit?.dropoff_time &&
					moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isBefore(
						moment(`${base_day} ${visit.dropoff_time}`, 'YYYY-MM-DD HH:mm')
					) &&
					!hasARelatedBoardingVisit
				) {
					setTimeError(true)
					setTimeErrorText('Start time cannot be before dropoff time.')
				} else if (added.isAfter(shift_final)) {
					setTimeError(true)
					setTimeErrorText('Service will end over 30 min after shift.')
				} else {
					setTimeError(false)
					setTimeErrorText('')
				}
			}
		}
	}, [selectedDate, selectedStaff])

	useEffect(() => {
		if (!tempDate) setProg(false)
		if (tempDate && !tempDate.isValid()) setProg(true)
		if (tempDate && tempDate.isValid()) setProg(false)
	}, [tempDate])

	const handleChangeStaffId = (visitStaff) => {
		const existStaffId = staff.some(({ staff_id }) => visitStaff === staff_id)
		if (existStaffId) handleStaffChange(visitStaff)
		else handleStaffChange(null)
	}

	useEffect(() => {
		if (visit) {
			if (visit.start_time) {
				handleDateChange(visit.start_time)
			} else {
				handleDateChange(null)
			}
			if (visit.staff_id) {
				handleChangeStaffId(visit.staff_id)
			} else {
				handleStaffChange(null)
			}
			if (visit.status) {
				setVisitStatus(visit?.status || {})
			}
		}
	}, [visit])

	const appointmentIsPending = visitStatus?.id === STATUS_ID.Pending

	const handleApproveVisit = async () => {
		if (visit && visit._id && appointmentIsPending) {
			handleClose()
			approveVisit(visit)
		}
	}

	let pet = visit?.pet || null

	if (!visit || !pet) return null

	const last_name = visit?.household?.accounts?.find((a) => a.primary)?.last_name || ''

	let addons = 'N/A'

	if (visit?.addons) addons = visit.addons

	const size = getSize(visit?.pet)

	const confirmDaycareTime = () => {
		assign(false)
		showDaycareWarning(false)
	}

	const issues = getDogIssues(pet, visit)

	const confirmDaycareDropOff = () => {
		// if there is a related daycare visit, prompt the user to confirm the time is correct
		if (visit?.related_visits?.find((v) => v.type === 'daycare')) {
			if (moment(selectedDate, 'HH:mm').isBefore(moment('09:00', 'HH:mm'))) {
				showDaycareWarning(true)
			} else {
				return assign(false)
			}
		} else {
			return assign(false)
		}
	}

	const assign = (validate = true) => {
		// if there is a related daycare visit, we need to confirm the start time is not before 9am
		if (validate) return confirmDaycareDropOff()

		const obj = {
			visit_id: visit._id,
			staff_id: selectedStaff,
			start_time: selectedDate
		}

		assignVisit(obj)
	}

	const goToVisit = () => {
		let base =
			process.env.REACT_APP_ENV === 'production'
				? 'https://admin-petcare.herokuapp.com'
				: 'https://admin-petcare-staging.herokuapp.com'

		let url = `/clients/${visit.household_id}/appointments/${visit._id}`

		window.open(`${base}${url}`, '_blank')
	}

	const goToPet = () => {
		let base =
			process.env.REACT_APP_ENV === 'production'
				? 'https://admin-petcare.herokuapp.com'
				: 'https://admin-petcare-staging.herokuapp.com'

		let url = `/clients/${visit.household_id}/pets/${visit.pet_ids[0]}`

		window.open(`${base}${url}`, '_blank')
	}

	const noChanges =
		manual && visit.start_time === selectedDate && visit.staff_id === selectedStaff ? true : false

	return (
		<div className={classes.outer}>
			{!manual && (
				<Typography
					style={{
						fontSize: 12,
						fontWeight: '800',
						color: gray[900],
						textTransform: 'uppercase',
						marginBottom: 16
					}}>
					{index + 1} / {needsAssignment.length} Appointments Need Action
				</Typography>
			)}
			<div className={classes.assignment} style={{ border: manual ? '2px solid #5326A5' : 'none' }}>
				<div className={classes.topBtns}>
					<IconButton onClick={handleClick}>
						<MoreHoriz />
					</IconButton>
					{manual && (
						<IconButton
							onClick={() => {
								setIsManual(false)
							}}>
							<Close />
						</IconButton>
					)}
					<Menu
						id="basic-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							'aria-labelledby': 'basic-button'
						}}>
						<MenuItem onClick={goToVisit}>View/Edit Appointment</MenuItem>
						{appointmentIsPending ? (
							<MenuItem onClick={handleApproveVisit}>Approve Appointment</MenuItem>
						) : null}
					</Menu>
				</div>
				<div className={classes.assignmentInnerContainer}>
					<div className={classes.topRow}>
						{!manual && needsAssignment.length > 1 && (
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<IconButton onClick={back}>
									<ArrowBackIosOutlined />
								</IconButton>
							</div>
						)}
						<div className={classes.petSection}>
							<Avatar
								className={classes.avatar}
								alt={pet.name}
								src={pet.image_url ? pet.image_url : null}
							/>
							<div style={{ width: '100%' }}>
								<div className={classes.petNameContainer}>
									<Typography variant="h6" onClick={goToPet} style={{ cursor: 'pointer' }}>{`${pet.name} ${last_name}`}</Typography>
									<PetAlert issues={issues} />
								</div>
								{visit.needs_grooming_consultation ? (
									<Typography variant="body2" style={{ textTransform: 'capitalize' }}>
										NEW CLIENT
									</Typography>
								) : null}
								<Typography
									style={{
										...getChipStyles(visitStatus?.name?.toLowerCase()),
										background: gray[100],
										fontSize: 16,
										fontWeight: '600',
										textTransform: 'capitalize'
									}}>
									{`\u2022`} {visitStatus?.name}
								</Typography>
								<Typography
									style={{
										backgroundColor: 'transparent',
										fontSize: 14,
										fontWeight: '600',
										textTransform: 'capitalize'
									}}>
									{visit.grooming_status || 'Upcoming'}
								</Typography>
							</div>
						</div>
						<div className={classes.sectionFourCols}>
							<Typography variant="body1" className={classes.sectionTitle}>
								Service
							</Typography>
							<Typography className={classes.sectionText} style={{ textTransform: 'capitalize' }}>
								Sub-Service: {visit.grooming_service_type === 'bath' ? 'Bath & Towel Dry' : visit.grooming_service_type}
							</Typography>
							<Typography className={classes.sectionText}>Enrichments: {addons}</Typography>
							<Typography className={classes.sectionText}>
								Duration: {visit.duration ? `${visit.duration} min` : 'Not Specified'}
							</Typography>
						</div>
						<div className={classes.sectionFourCols}>
							<Typography variant="body1" className={classes.sectionTitle}>
								Time
							</Typography>
							<Typography className={classes.sectionText}>
								Drop-off Time:{' '}
								{visit.dropoff_time_string ? visit.dropoff_time_string : 'Not Specified'}
							</Typography>
							<Typography className={classes.sectionText}>
								Start Time:{' '}
								{visit.start_time
									? moment(visit.start_time, 'HH:mm').format('h:mm a')
									: 'Not Specified'}
							</Typography>
							<Typography className={classes.sectionText}>
								Pick-up: {visit?.pickup_time_string || 'Not Specified'}
							</Typography>
						</div>
						<div className={classes.sectionFourCols}>
							<Typography variant="body1" className={classes.sectionTitle}>
								Basics
							</Typography>
							<Typography className={classes.sectionText}>
								Breed: {visit?.pet?.breeds?.join(', ')}
							</Typography>
							<Typography className={classes.sectionText}>Size: {size.toUpperCase()}</Typography>
							<Typography className={classes.sectionText}>
								Coat Type: {visit?.pet?.coat_type}
							</Typography>
						</div>
						{!manual && needsAssignment.length > 1 && (
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<IconButton onClick={next}>
									<ArrowForwardIosOutlined />
								</IconButton>
							</div>
						)}
					</div>
					<div className={classes.topRow}>
						<div className={classes.sectionTwoCols}>
							<div className={classes.sectionTwoColsContainer}>
								<Typography variant="overline" style={{ fontSize: '.75rem' }}>
									Notes from client
								</Typography>
								<Typography variant="body1" style={{ fontSize: '1rem' }}>
									{visit?.notes_from_client || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.sectionTwoCols}>
							<div className={classes.sectionTwoColsContainer}>
								<Typography variant="overline" style={{ fontSize: '.75rem' }}>
									Notes from team
								</Typography>
								<Typography variant="body1" style={{ fontSize: '1rem' }}>
									{visit?.notes_from_team || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
					</div>
					<div className={classes.toolbar2}>
						<div className={classes.barOuter}>
							<TextField
								label="Staff Member"
								variant="filled"
								disabled={visit.grooming_status === 'Completed' || !!isBeforeToday}
								value={selectedStaff || ''}
								onChange={(val) => {
									handleChangeStaffId(val.target.value)
								}}
								style={{ width: '100%' }}
								select>
								{staff
									.filter((s) => {
										if (visit?.staff_id === s.staff_id) return true
										if (s.remaining_minutes < visit?.duration) return false
										return (
											!visit.grooming_service_type ||
											s.permitted_grooming_services.includes(visit?.grooming_service_type)
										)
									})
									.map((s) => {
										return <MenuItem value={s.staff_id}>{s.full_name}</MenuItem>
									})}
							</TextField>
							<Button
								variant="text"
								className={classes.xButton}
								disabled={visit.grooming_status === 'Completed' || !!isBeforeToday}
								onClick={() => handleStaffChange(null)}>
								X
							</Button>
						</div>
						<div className={classes.barOuter}>
							<KeyboardTimePicker
								error={timeError}
								helperText={timeErrorText}
								label="Start Time"
								inputVariant="filled"
								inputRef={valueRef}
								disabled={visit.grooming_status === 'Completed' || !!isBeforeToday}
								mask="__:__ _M"
								value={selectedDate ? moment(selectedDate, 'HH:mm').toDate() : null}
								onChange={(date) => {
									if (date) {
										handleDateChange(date.format('HH:mm'))
									}
									setDate(date)
								}}
							/>
							<Button
								variant="text"
								className={classes.xButton}
								disabled={visit.grooming_status === 'Completed' || !!isBeforeToday}
								onClick={() => handleDateChange(null)}>
								X
							</Button>
						</div>
						<Button
							variant="contained"
							color="secondary"
							style={{ width: 124 }}
							onClick={assign}
							disabled={
								!!prog ||
								!!timeError ||
								visit.grooming_status === 'Completed' ||
								noChanges ||
								!!isBeforeToday
							}>
							Assign
						</Button>
					</div>
				</div>
			</div>
			<Confirmation
				isShown={daycareWarning}
				body={''}
				confirmButtonText="Continue"
				title="ARE YOU SURE?"
				setIsShown={showDaycareWarning}
				onConfirmDelete={confirmDaycareTime}>
				<Typography
					variant="body2"
					style={{
						fontFamily: 'Nunito',
						color: gray[900],
						fontSize: '16px',
						lineHeight: '22px',
						fontWeight: '400',
						marginBottom: 16,
						marginTop: 6
						// marginTop: 16
					}}>
					Please schedule the grooming appointment for this client{' '}
					<span style={{ fontWeight: 'bold' }}>after 9:00am</span> as they have a related daycare
					appointment. If you proceed with a time before 9:00am, inform the client of both appointment
					start/drop-off times accordingly.
				</Typography>
			</Confirmation>
		</div>
	)
}

export default GroomingAssignment

const Calendars = ({ date, staff, visits, selectEvent, selectedVisitId, specialKey, time_zone }) => {
	// all the ref width nonsense is necessary to hide the time gutter on the calendars after the 1st one. There isn't a prop to hide it for some reason
	const ref = useRef(null)

	const [anchorEl, setAnchorEl] = useState(null)
	const [openStaff, setStaffOpen] = useState(false)

	const selectedFilters = useSelector((state) => state.specific.visits.selectedGroomingAssignmentFilters)

	let filteredStaff = staff
	if (selectedFilters.team_member.length) {
		const filterCondition = ({ full_name }) => selectedFilters.team_member.includes(full_name)
		filteredStaff = (filteredStaff && filteredStaff.filter(filterCondition)) || []
	}
	if (selectedFilters.role.length) {
		filteredStaff = filteredStaff.filter(({ position }) => selectedFilters.role.includes(position))
	}
	const classes = useStyles()
	const clone = moment(date).format('YYYY-MM-DD')
	const min = moment(`${clone} 06:00`, 'YYYY-MM-DD HH:mm').toDate()
	const max = moment(`${clone} 22:00`, 'YYYY-MM-DD HH:mm').toDate()

	const width = ref?.current?.offsetWidth || 0
	const containerWidth = width - 75
	const otherWidth = containerWidth > 0 ? containerWidth / 4 : 161
	const maxwidth = (otherWidth - 10) / 2

	const eventProp = (event) => {
		if (event.isBackground)
			return {
				style: {
					backgroundColor: gray[100],
					borderWidth: 0
				}
			}

		const style = {
			backgroundColor: event?.related ? '#FEDFB3' : '#F0EDFB',
			color: gray[900],
			padding: 8,
			// maxWidth: maxwidth,
			borderRadius: 6
			// width: '50%',
		}

		if (event?.visit?.status?.id === 1) style.backgroundColor = '#FFB99C'

		if (selectedVisitId === event?.visit?._id) {
			style.borderWidth = 2
			style.borderColor = '#5326A5'
		} else {
			style.borderWidth = 0
		}

		return { style }
	}

	const BigEvent = ({ event }) => {
		if (event.isBackground) return <div></div>

		let { visit } = event

		let ourStaff = staff.find((s) => s.staff_id === event.visit.staff_id)

		if (!ourStaff) return null

		let selectedDate = visit.start_time

		let hasError = false
		let startError = false
		let errorMessage = ''

		let base_day = moment(ourStaff.StartTimeLocalized).format('YYYY-MM-DD')

		let shift_start = moment(ourStaff.StartTimeLocalized)
		let shift_end = moment(ourStaff.EndTimeLocalized)
		let shift_final = moment(ourStaff.EndTimeLocalized).add(30, 'minutes')
		let added = moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').add(visit.duration, 'minutes')

		const permitted_services = ourStaff.permitted_grooming_services.map(s => {
			if (s === 'basic bath') return 'bath'

			return s
		})

		if (moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isBefore(moment(shift_start))) {
			hasError = true
			startError = true
			errorMessage = 'Error: Start time scheduled before shift'
		} else if (moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isAfter(moment(shift_end))) {
			hasError = true
			startError = true
			errorMessage = 'Error: Start time scheduled after shift end'
		} else if (
			visit?.dropoff_time &&
			moment(`${base_day} ${selectedDate}`, 'YYYY-MM-DD HH:mm').isBefore(
				moment(`${base_day} ${visit.dropoff_time}`, 'YYYY-MM-DD HH:mm')
			)
		) {
			hasError = true
			startError = true
			errorMessage = 'Error: Start time scheduled before dropoff time'
		} else if (added.isAfter(shift_final)) {
			hasError = true
			errorMessage = 'Error: service will end over 30 min after shift end'
		}

		if (
			visit.grooming_service_type &&
			!permitted_services.includes(visit.grooming_service_type)
		) {

			hasError = true
			errorMessage = 'Error: Staff not qualified for service'
		}

		if (visit?.status?.id === 1) {
			hasError = true
			errorMessage = "Notice: this appointment's status is still 'Pending'"
		}

		if (visit?.needs_grooming_consultation) {
			hasError = true
			errorMessage = 'New grooming pet consultation needed'
		}

		return (
			<PopupState variant="popover" popupId="demoPopover" disableAutoFocus={true}>
				{(popupState) => (
					<div style={{ height: '100%' }}>
						<div
							{...bindHover(popupState)}
							style={{
								display: 'flex',
								flexDirection: event.duration > 35 ? 'column' : 'row',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis',
								position: 'relative',
								height: '100%'
							}}>
							{hasError && (
								<i
									class="fas fa-calendar-exclamation"
									style={{
										color: '#EB4C4C',
										position: 'absolute',
										top: 0,
										right: 5
									}}></i>
							)}
							<Typography className={classes.eventText}>
								{event.pet_name}
								{event.duration > 35 ? '' : ', '}
							</Typography>
							<Typography className={classes.eventText2}>
								{event.start_time} ({event.duration} min)
							</Typography>
						</div>
						<HoverPopover
							{...bindPopover(popupState)}
							className={classes.popover}
							classes={{
								paper: classes.paper
							}}
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'left'
							}}
							transformOrigin={{
								vertical: 'bottom',
								horizontal: 'right'
							}}>
							<div className={classes.popup}>
								<div
									className={classes.popupLeft}
									style={{ color: hasError ? '#EB4C4C' : gray[900] }}>{`\u2022`}</div>
								<div className={classes.popupRight}>
									<Typography
										className={classes.popupTitle}
										style={{ textTransform: 'capitalize' }}>
										{event.pet_name}, {event.service}
									</Typography>
									<Typography className={classes.popupDate}>
										{moment(event.start).format('dddd, MMMM D')}
									</Typography>
									<Typography
										className={classes.popupDate}
										style={{ textTransform: 'capitalize' }}>
										{visit.status.name}
									</Typography>
									<Typography
										className={classes.popupDate}
										style={{ textTransform: 'capitalize' }}>
										{visit.grooming_status || 'Upcoming'}
									</Typography>
									<Typography className={classes.popupDate}>--</Typography>
									<Typography className={classes.popupDate}>
										Drop-off time: {visit.dropoff_time_string || 'N/A'}
									</Typography>
									<Typography
										className={classes.popupDate}
										style={{ color: startError ? '#EB4C4C' : gray[700] }}>
										Start time:{' '}
										{visit.start_time
											? moment(visit.start_time, 'HH:mm').format('h:mm a')
											: 'N/A'}
									</Typography>
									<Typography className={classes.popupDate}>
										Pick up time: {visit.pickup_time_string || 'N/A'}
									</Typography>
									<Typography className={classes.popupDate}>
										Enrichments: {visit.addons || 'None'}
									</Typography>
									{errorMessage ? (
										<Typography className={classes.popupError}>{errorMessage}</Typography>
									) : null}
								</div>
							</div>
						</HoverPopover>
					</div>
				)}
			</PopupState>
		)
	}

	const formats = {
		eventTimeRangeFormat: () => {
			return ''
		}
	}

	const hours = [
		'6AM',
		'7AM',
		'8AM',
		'9AM',
		'10AM',
		'11AM',
		'12PM',
		'1PM',
		'2PM',
		'3PM',
		'4PM',
		'5PM',
		'6PM',
		'7PM',
		'8PM',
		'9PM'
	]

	return (
		<div style={{ paddingLeft: 16, paddingRight: 16 }}>
			<GroomingAssignmentFilters />
			<div
				ref={ref}
				style={{
					width: '100%',
					padding: 16,
					// overflowY: 'scroll',
					height: 1800,
					backgroundColor: gray[100],
					paddingTop: 0
				}}>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						overflowX: 'auto'
					}}>
					<div
						style={{
							// height: 1350,
							width: 75,
							minWidth: 75,
							marginRight: 15,
							position: 'sticky',
							left: 0,
							zIndex: 100,
							borderRadius: 6,
							overflow: 'hidden'
						}}>
						<Collapse in={!!openStaff}>
							<div
								style={{
									height: 80,
									width: 10
								}}></div>
						</Collapse>
						<div
							style={{
								opacity: 0,
								height: 74,
								width: 75
							}}></div>
						{hours.map((h) => {
							return (
								<div
									style={{
										width: 75,
										height: 92.16,
										backgroundColor: gray[300],
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										// borderTop: '1px solid #777679',
										padding: 6
									}}>
									<Typography style={{ fontSize: 12, fontWeight: '700', color: gray[700] }}>
										{h}
									</Typography>
								</div>
							)
						})}
					</div>
					<div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
						{filteredStaff.map((s, index) => {
							const appts = visits
								.filter((v) => v.staff_id === s.staff_id && !!v.start_time)
								.map((v) => {
									let d = v.duration || 90
									d = Math.floor(d / s.speed_factor)
									let last_name = v?.household?.accounts?.find((a) => a.primary)?.last_name || ''

									return {
										related: v.related_pc,
										label: null,
										duration: d,
										pet_name: `${v.pet.name} ${last_name}`,
										service: v.grooming_service_type === 'bath' ? 'Bath & Towel Dry' : v.grooming_service_type || 'No Service Selected',
										start_time: moment(v.start_time, 'HH:mm').format('h:mma'),
										title: `${v.pet.name} - ${v.grooming_service_type || 'No Service Selected'
											} - ${v.duration} min`,
										start: moment(`${clone} ${v.start_time}`, 'YYYY-MM-DD HH:mm').toDate(),
										end: moment(`${clone} ${v.start_time}`, 'YYYY-MM-DD HH:mm')
											.add(d, 'minutes')
											.toDate(),
										visit: v
									}
								})

							const shiftArray = [
								{
									start: moment(s.StartTimeLocalized).tz(time_zone).format('YYYY-MM-DD HH:mm'),
									end: moment(s.EndTimeLocalized).tz(time_zone).format('YYYY-MM-DD HH:mm'),
									isBackground: true
								}
							]

							const overCap = s.remaining_minutes < 0 ? true : false

							return (
								<div
									style={{
										minWidth: otherWidth,
										position: 'relative',
										overflow: 'hidden',
										marginRight: 16
									}}>
									<div className={classes.nameRow} style={{}}>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'flex-start'
											}}>
											<div
												className={classes.nameRowInt}
												onClick={() => setStaffOpen(!openStaff)}
												style={{
													position: 'relative',
													borderBottomLeftRadius: openStaff ? 0 : 6,
													borderBottomRightRadius: openStaff ? 0 : 6
												}}>
												<Typography className={classes.name}>{s.full_name}</Typography>
												{openStaff ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
												{overCap && (
													<i
														class="fas fa-calendar-exclamation"
														style={{
															color: '#EB4C4C',
															position: 'absolute',
															top: 13,
															right: 50
														}}></i>
												)}
											</div>
										</div>
										<Collapse in={!!openStaff}>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'flex-start'
												}}>
												<div
													style={{
														backgroundColor: gray[300],
														borderBottomLeftRadius: 6,
														borderBottomRightRadius: 6,
														padding: 16,
														paddingTop: 0,
														width: '100%'
													}}>
													<Typography className={classes.groomerText}>
														Role: {s.position}
													</Typography>
													<Typography
														className={classes.groomerText}
														style={{ color: overCap ? '#EB4C4C' : gray[700] }}>
														Schedule Capacity: {s.capacity_string}
													</Typography>
													<Typography className={classes.groomerText}>
														Shift:{' '}
														{moment(s.StartTimeLocalized)
															.tz(time_zone)
															.format('h:mm a')}{' '}
														-{' '}
														{moment(s.EndTimeLocalized).tz(time_zone).format('h:mm a')}
													</Typography>
												</div>
											</div>
										</Collapse>
									</div>

									<Calendar
										dayLayoutAlgorithm="no-overlap"
										key={specialKey}
										localizer={localizer}
										events={appts}
										defaultDate={date}
										time_zone={time_zone}
										defaultView={Views.DAY}
										backgroundEvents={shiftArray}
										scrollToTime={false}
										getNow={() => null}
										min={min}
										max={max}
										toolbar={false}
										views={['day']}
										startAccessor="start"
										endAccessor="end"
										style={{
											height: 1477,
											width: otherWidth + 75,
											position: 'absolute',
											right: 0
										}}
										eventPropGetter={eventProp}
										onSelectEvent={selectEvent}
										formats={formats}
										components={{
											event: BigEvent
										}}
									/>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		</div>
	)
}
